<template lang="pug">
.covid-card
  v-card(@click="index = 0", max-width="300px")
    v-img(:src="img + '?resize=1&w=300'", :aspect-ratio="0.8", :alt="title")
    v-card-subtitle.pb-0.font-weight-bold(:datetime="date") {{ time }}
    v-card-title.black--text.text-uppercase.font-weight-bold.covid-card-title.py-2.text-body-1 {{ title }}
  vue-gallery-slideshow(:images="[img]", :index="index", @close="index = null")
</template>

<script>
import VueGallerySlideshow from "vue-gallery-slideshow";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    index: null,
  }),
  computed: {
    time() {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "full" }).format(
        new Date(this.date)
      );
    },
  },
  components: {
    VueGallerySlideshow,
  },
};
</script>

<style>
.covid-card-title {
  line-height: 20px !important;
}
.covid-card .vgs__container {
  height: 90vh !important;
}

.covid-card .vgs__container {
  height: 80vh !important;
}
@media (max-width: 767px) {
  .covid-card .vgs__container {
    top: 30%;
  }
}
</style>
